require("jquery-match-height");
import MicroModal from "micromodal";

export const archiveRental = () => {
  if (document.body.classList.contains("post-type-archive-rental")) {
    $(".mh-1").matchHeight({
      byRow: false,
    });

    const modal = () => {
      MicroModal.init({
        onShow: () => {
          document.body.classList.add("body-scroll-lock");
        },
        onClose: () => {
          document.body.classList.remove("body-scroll-lock");
        },
      });
    };
    modal();

    document.addEventListener("alpine:init", () => {
      Alpine.data("rentalSearchForm", () => ({
        brand: "",
        impression: [],
        pattern: [],
        mainColor: [],
        resetAllForms() {
          this.brand = "";
          this.impression = [];
          this.pattern = [];
          this.mainColor = [];
        },
      }));
    });
  }
};
